import { legacyChartActionKey } from '../models/legacyChartActions';
import { isOwnedChart } from './legacyChartLoading';

// Actions cross the frame boundary; business operations stay in the existing
// SPA dialogs. Validate the frame, origin, session and selected analysis.
export default {
  data: () => ({ legacyActionsState: null }),
  watch: {
    isIframeLoading() { this.publishChartActions(); },
    iframeError() { this.publishChartActions(); },
    isMobile() { this.publishChartActions(); }
  },
  created() { window.addEventListener('message', this.handleChartAction); },
  beforeDestroy() { window.removeEventListener('message', this.handleChartAction); },
  methods: {
    updateChartActions(state) {
      this.legacyActionsState = state;
      this.$nextTick(this.publishChartActions);
    },
    publishChartActions() {
      if (!this.legacyActionsState) return;
      this.chartMessage('legacy-chart-actions-state', {
        actions: { ...this.legacyActionsState, visible: !this.isMobile,
          disabled: Boolean(this.isIframeLoading || this.iframeError) }
      });
    },
    handleChartAction(event) {
      const data = event.data;
      if (!data || !['legacy-chart-actions-ready', 'legacy-chart-action'].includes(data.type)) return;
      const frame = this.chartFrame();
      if (!frame || !isOwnedChart(frame.src) || event.source !== frame.contentWindow ||
        event.origin !== new URL(frame.src, window.location.href).origin || data.sessionId !== this.iframeSessionId) return;
      if (data.type === 'legacy-chart-actions-ready') { this.publishChartActions(); return; }
      if (this.isMobile || this.isIframeLoading || this.iframeError || !this.legacyActionsState ||
        data.key !== legacyChartActionKey(this._g_SelectedTicker) || data.key !== this.legacyActionsState.key ||
        !['favorites', 'portfolio'].includes(data.action)) return;
      const list = this.$refs.legacyStocks;
      if (!list || !list.openStockAction(data.action, data.key)) return;
      if (this.chartUsage) {
        try {
          const stock = this._g_SelectedTicker;
          this.chartUsage.track('interaction', 'chart_header', data.action, {
            input: 'click', ticker: stock.ticker, direction: stock.direccio, entry_type: stock.tipus_entrada
          });
        } catch (_) { /* Profiling must never interrupt product actions. */ }
      }
    }
  }
};
